import { z } from 'zod';

/** Who owns a role's definition: built-in roles are synced from this package, customer roles are created by users. */
export enum RoleManagedByEnum {
  Builtin = 'builtin',
  Customer = 'customer',
}
export const RoleManagedBy = z.enum(RoleManagedByEnum);
export type RoleManagedBy = z.infer<typeof RoleManagedBy>;
